module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"booking":{"title":"Buy an E-Ticket","link":"/booking"},"giftcards":{"title":"Gift Vouchers","subtitle":"& Hardtickets","link":"/giftcards"},"yullbe":{"title":"Buy YULLBE WUNDERLAND tickets","link":"/yullbe"}}}')
  delete Component.options._Ctor
}
